import { createAction } from "@reduxjs/toolkit";
export const ROUTE_CHANGED = "router/ROUTE_CHANGED";
export const setRouteChanged = createAction(ROUTE_CHANGED);
export const routeChanged = (location) => ({
    type: ROUTE_CHANGED,
    payload: location,
});
